<template>
	<div class="content">
		<div class="content_head">
			<p>
				<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
					<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
				</select>
				<select v-model="selectShopID" @change="pageIndex=1;getData()"
					v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
					<option v-for="i in  Shop" :value="i.ShopID">{{i.ShopName}}</option>
				</select>

				<input type="text" @keypress.enter="pageIndex=1;getData()" placeholder="会员手机号|扫描会员二维码|会员姓名"
					class="search" v-model="searchText" />
				<button type="button" class="button " @click="pageIndex=1;getData()" title="点击进行查找">查找</button>
				<button type="button" class="button add" @click="Edit='up'">+新会员</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>手机号</th>
						<th>会员归属</th>
						<th>到期时间</th>
						<th>会员等级</th>
						<th>会员缴费</th>
						<th>押金</th>
						<th>书盒</th>
						<th>待还书</th>
						<th>会员状态</th>
						<th>负责人</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in Customer">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.CustomerPhone}}<br />
							{{i.CustomerName}}<br />
							<span v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1" >{{i.Customerpwd}}</span>
						</td>

						<td>
							{{i.ShopName}}
						</td>

						<td>
							开始时间:<span class="red">{{ $moment (i.VipBeginDate).format('YYYY年MM月DD日')}} <br /></span>
							截止时间:<span class="red">{{ $moment (i.VipEndDate).format('YYYY年MM月DD日')}}</span>
						</td>
						<td>
							{{ i.vipLevl |rmb}}
						</td>
						<td class="red">
							{{i.Disbursements |rmb}}
						</td>
						<td class="red">
							{{i.Deposit |rmb}}
						</td>
						<td class="red">
							{{i.boxMoney |rmb}}
						</td>
						<td>
							{{i.borrowBooksCount +'本' }}
						</td>
						<td>
							{{i.CustomerState | state }}
						</td>
						<td>
							{{i.BelongTo }}
						</td>
						<td>
							<button type="button" @click="updateCode(i)" title="点击更新会员码" class="button">更新二维码</button>
							<br />
							<button type="button" @click="lookCode(i)" title="点击查看会员码" class="button">查看会员码</button>
							<br />
							<button type="button" @click="resetPWD(i)" title="点击重置密码"
								class="button">重&nbsp;置&nbsp;密&nbsp;码</button><br />
							<button type="button" @click="$router.push('/newCustomers/customerAddress/'+i.CustomerID)" title="点击设置借书地址" class="button">借 书 地 址</button>	
								
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-if="$store.state.user.UserType <= 1" class="foot_pages">
			共计: <span>{{count+'人'}}</span>
			<button type="button" class="button" @click="exportExce">导出Excel</button>

			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

		<div class="booksMangement" v-show="Edit!='' && Edit!='code'">
			<div v-show="Edit!=''">
				<div>
					<span class="red">*</span>手机号:
				</div>
				<div>
					<input type="text" v-model="CustomerPhone" placeholder="会员手机号" required="required" maxlength="11" />
					<span class="err">{{$uil.checkPhone(CustomerPhone)?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>会员姓名:
				</div>
				<div>

					<input type="text" v-model="CustomerName" required="required" placeholder="会员姓名" />

					<span class="err">{{$uil.checkchinese(CustomerName,2,6)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red"></span>账号孩子:
				</div>
				<div>
					<input type="text" v-model="CustomerChild" title="如果是双胞胎填2,以此类推" />
					<span class="err"> </span>
				</div>

				<div>
					<span class="red"></span>学生年龄:
				</div>
				<div>
					<input type="text" v-model="age" title="小孩儿的年龄" />
					<span class="err"> </span>
				</div>


				<div>
					<span class="red"></span>学生学校:
				</div>
				<div>
					<input type="text" v-model="school" title="小孩儿的学校" />
					<span class="err"> </span>
				</div>



				<div>
					<span class="red">*</span>会员分类:
				</div>
				<div>
					<select v-model="VipLevlIDIndex" @change="selectVipLevl">
						<option v-for="(i,index) in vipLevl" :value="index">{{i.Price}}</option>

					</select>
				</div>

				<div>
					<span class="red">*</span>会员时长:
				</div>
				<div>
					<button class="buttonSamll" style="margin:0rem .3rem ;padding: .0rem .3rem;"
						@click="changyear('-')">-</button>
					<input type="text" v-model="year" style="width: 11.8rem;" readonly="readonly" />
					<button class="buttonSamll" style="margin:0rem .3rem ;padding: .0rem .3rem;"
						@click="changyear('+')">+</button>
					<span class="err">{{year>0?' ':'×'}}</span>
				</div>


				<div>
					<span class="red">*</span>开始时间:
				</div>
				<div>
					<input type="text" v-model="VipBeginDate" />
					<span class="err">{{$uil.checkDate(VipBeginDate)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>结束时间:
				</div>
				<div>
					<input type="text" v-model="VipEndDate" />
					<span class="err">{{$uil.checkDate(VipEndDate)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>应收费:
				</div>
				<div>
					<input type="text" v-model="PayMoney" readonly="readonly" />
					<span class="err">{{PayMoney>0?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>实收费:
				</div>
				<div>
					<input type="text" v-model="Disbursements" />
					<span class="err">{{Disbursements>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>押金:
				</div>
				<div>
					<input type="text" v-model="Deposit" />
					<span class="err">{{Deposit>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red"></span>送书盒:
				</div>
				<div>
					<input type="text" v-model="boxMoney" />
					<span class="err"> </span>
				</div>

				<div>
					<span class="red"></span>负责人:
				</div>
				<div>
					<input type="text" v-model="BelongTo" />
					<span class="err">{{BelongTo.trim()==''? '×':''}} </span>
				</div>

				<div>
					<span class="red">*</span>合计:
				</div>
				<div>
					<span>应收:{{PayMoney*1+Deposit*1 + boxMoney*1}}¥</span>
					&nbsp; &nbsp; &nbsp; &nbsp;
					<span>实收:{{Disbursements*1+Deposit*1 + boxMoney*1}}¥</span>
				</div>
				<div>
				</div>
				<div>

					<button class="button" :class="{'disabled':!checkCustomer}" :disabled="!checkCustomer"
						@click="editCustomer">{{ CustomerID==0?'新增':'修改'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="Edit=''">取消</button>
				</div>
			</div>
		</div>
		<div class="edit" v-if="Edit=='code'" @click="hideCode">
			<img :src="CustomerQRcode" />
		</div>
	</div>

</template>

<script>
	import j from './j.js'
	export default j
</script>

<style>
</style>
